document.addEventListener('DOMContentLoaded', () => {
  const displayMenus = document.querySelectorAll('.display-menu');

  // Use event delegation for better performance
  displayMenus.forEach(displayMenu => {
    const section = displayMenu.closest('.shopify-section');
    if (!section) return;

    // Cache DOM elements
    const tabTriggers = section.querySelectorAll('[data-tab-trigger]');
    const tabContents = section.querySelectorAll('[data-tab-content]');

    // Create lookup map for faster content finding
    const contentMap = new Map();
    tabContents.forEach(content => {
      const tabId = content.dataset.tabContent;
      if (tabId) contentMap.set(tabId, content);
    });

    // Use event delegation on the section
    section.addEventListener('click', event => {
      const trigger = event.target.closest('[data-tab-trigger]');
      if (!trigger || trigger.classList.contains('display-menu__tab-trigger--active')) {
        return;
      }

      const tabId = trigger.dataset.tabTrigger;
      const targetContent = contentMap.get(tabId);

      if (!targetContent) return;

      // Remove active classes efficiently
      section
        .querySelector('.display-menu__tab-trigger--active')
        ?.classList.remove('display-menu__tab-trigger--active');
      section
        .querySelector('.display-menu__tab--active')
        ?.classList.remove('display-menu__tab--active');

      // Add active classes
      trigger.classList.add('display-menu__tab-trigger--active');
      targetContent.classList.add('display-menu__tab--active');
    });
  });
});
